import React from 'react';
import './SkeletonBlock.css';

function SkeletonBlock({
  as: Tag = 'div',
  className = '',
  height = 12,
  radius = 'var(--radius-8)',
  width = '100%',
  style = {},
  ...rest
}) {
  return (
    <Tag
      className={`skeleton-block${className ? ` ${className}` : ''}`}
      style={{
        width,
        height,
        borderRadius: radius,
        ...style
      }}
      aria-hidden="true"
      {...rest}
    />
  );
}

export default SkeletonBlock;
